module.exports = __webpack_public_path__ + "static/VetCode_2-fecc859d6c450bc118851984ea58b636.png";